import '../../style/base.css';
import '../../info/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/icon/style/index.js
// module id = 416
// module chunks = 0